import { Link } from "wouter";
import type { Brand } from "@shared/schema";

interface BrandLogoProps {
  brand: Brand;
}

export default function BrandLogo({ brand }: BrandLogoProps) {
  return (
    <Link
      href={`/shop?brand=${encodeURIComponent(brand.slug)}`}
      className="flex items-center justify-center h-20 rounded-xl bg-card shadow-sm hover:shadow-md hover:scale-105 transition-all duration-200 cursor-pointer px-3 sm:px-6 overflow-hidden"
    >
      {brand.logo ? (
        <img
          src={brand.logo}
          alt={`${brand.name} logo`}
          className="h-auto w-auto max-h-12 sm:max-h-14 max-w-full object-contain"
        />
      ) : (
        <span className="text-base sm:text-lg font-serif font-semibold text-charcoal dark:text-white whitespace-nowrap truncate">
          {brand.name}
        </span>
      )}
    </Link>
  );
}
